import { FilterResult } from 'src/app/shared/components/odata-filter/models/filter-result';
import { Image } from 'src/app/people/models/image';
import { PersonScenarioReportModel } from '../../../reports/credential-scenario-report/person-scenario-report.model';
import { CredentialApplicationDefinitionType } from '../../models/credential/CredentialApplicationDefinitionType';
import { BaseCredentialApplicationReportModel } from './base-credential-application-report.model';

export class PersonCredentialApplicationReportModel extends BaseCredentialApplicationReportModel {
  public personId: string;
  public personCredentialId: string;
  public imageId: string;
  public image: Image;
  public email: string;
  public firstName: string;
  public middleName: string;
  public lastName: string;
  public fullName: string;
  public suffix: string;
  public scenarios: PersonScenarioReportModel[] = [];
  public status: string;

  static parse(data: any): PersonCredentialApplicationReportModel {
    if (!data) return null;
    let model = new PersonCredentialApplicationReportModel();
    Object.assign(model, data);
    if (model.imageId) {
      model.image = new Image(model.imageId);
    }

    if (data.credentialApplicationType == CredentialApplicationDefinitionType.Initial) {
      model.credentialApplicationType = 'New Credential';
    }
    return model;
  }
}

export class PersonCredentialApplicationReportFilterResult implements FilterResult {
  public count: number;
  public values: any[] = [];
  public nextLink: string;

  public parse(response: any) {
    let result = new PersonCredentialApplicationReportFilterResult();
    result.count = response['@odata.count'];
    result.values = response.value.map((report) =>
      PersonCredentialApplicationReportModel.parse(report)
    );
    result.nextLink = response['@odata.nextLink'];
    return result;
  }
}
